import _ from 'underscore';
import { Component } from 'react';
import DefaultSearchResult from './default-search-result';
import SearchResultShowAdvanced from './search-result-show-advanced';
import SearchLoadingIndicator from './search-loading-indicator';

export default class SearchBarDropdown extends Component {
  TRANSLATED_NO_RESULTS_FOUND = I18n.t('js.learner.search.no_results_found');

  render() {
    let { searching, isWithinModal, showAdvancedSearchOption, accessibilityProps } = this.props;

    const emptyText = this.props.emptyText || this.TRANSLATED_NO_RESULTS_FOUND;

    const results = this.getResults();
    showAdvancedSearchOption = showAdvancedSearchOption && !searching;
    const searchHadNoResults = !searching && results.length === 0;
    const emptyMessage = searchHadNoResults ? <div className="search-bar-dropdown--empty">{emptyText}</div> : undefined;
    const loadingIndicator = searching ? <SearchLoadingIndicator /> : undefined;
    const modalClass = isWithinModal ? 'search-bar-dropdown--within-modal' : '';

    return (
      <div className={`search-bar-dropdown ${modalClass}`} {...accessibilityProps}>
        {results}
        {showAdvancedSearchOption && this.renderAdvancedSearchOption(searchHadNoResults)}
        {!showAdvancedSearchOption && emptyMessage}
        {loadingIndicator}
      </div>
    );
  }

  getResults = () => {
    const { renderResult, activeIndex } = this.props;
    return _.map(this.props.results, (result, index) =>
      typeof renderResult === 'function' ? (
        renderResult(result, index === activeIndex, index)
      ) : (
        <DefaultSearchResult key={index} {...result} isActive={index === activeIndex} />
      ),
    );
  };

  renderAdvancedSearchOption = (searchHadNoResults) => {
    const { activeIndex, controlledQuery, emptyText, results } = this.props;
    const queryParam = controlledQuery ? `?query=${controlledQuery}` : '';

    return (
      <SearchResultShowAdvanced
        isActive={results && results.length === activeIndex}
        onSelect={() => {
          window.location = `/advanced_search/${queryParam}`;
        }}
        emptyText={searchHadNoResults && emptyText}
      />
    );
  };
}
